module.exports = __webpack_public_path__ + "img/gh_wechat.40bea48b.jpg";